module.exports = __webpack_public_path__ + "img/1.774e3ab9.png";